import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { icons } from "../../../constants";
import { isEmpty } from "../../../utils/common";
import Input from "../../../library/components/input.component";
import {
  setPasswordForForgotPasswordAction,
  setPasswordForNewUserAction,
} from "../store/auth.action";
import { getPathPrefix } from "../../../utils/coreUtils";
import ToastUtils from "../../../utils/ToastUtils";

const FooterButton = ({
  handleContinue,
  title,
  buttonStyle = {},
  disabled = false,
  isLoading,
}) => {
  const [t] = useTranslation();

  return (
    <>
      <div className="form-group text-center">
        <button
          onClick={handleContinue}
          type="submit"
          className="btn btn-fill text-uppercase"
          disabled={disabled}
          style={buttonStyle}
        >
          {isLoading && (
            <img
              src={"https://www.ssdream.co.kr/front/event/img/loading.gif"}
              height={"25"}
              width={"25"}
            />
          )}
          {title}
        </button>
      </div>
      <div className="form-group text-center">
        <NavLink to={getPathPrefix("login")} className="">
          {t("CommonKeys.backTo")} <b>{t("CommonKeys.login_hyphen")}</b>
        </NavLink>
      </div>
    </>
  );
};

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const changeForgetPasswordMailData = useSelector(
    (state) => state.authReducer.changeForgetPasswordMailData
  );
  const companyDetails = useSelector((state) => state?.company);
  const isLoading = useSelector((state) => state.authReducer.isLoading);
  const [t] = useTranslation();

  const [resetPasswordState, setResetPasswordState] = useState({
    password: "",
    confirmPassword: "",
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const handleChange = (e, type) => {
    resetPasswordState[type] = e.target.value;
    setResetPasswordState({
      ...resetPasswordState,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !isEmpty(resetPasswordState.password) &&
      !isEmpty(resetPasswordState.confirmPassword)
    ) {
      if (resetPasswordState.password === resetPasswordState.confirmPassword) {
        if (localStorage.getItem("encKeyLink") != null) {
          await dispatch(
            setPasswordForNewUserAction(
              localStorage.getItem("encKeyLink"),
              resetPasswordState.password,
              location.state.otpStates,
              companyDetails?.companyId
            )
          )
            .then((res) => {
              setIsSuccess(true);
              if (res.status !== 200) {
                ToastUtils.serverError(t(`statusCodes.${res?.code}`));
              } else {
                toast.success(t(`statusCodes.${res?.code}`));
              }
            })
            .catch((e) => {
              toast.error(e.data.message);
            });
        } else {
          await dispatch(
            setPasswordForForgotPasswordAction(
              changeForgetPasswordMailData,
              resetPasswordState.password,
              location?.state?.otpStates,
              companyDetails?.companyId
            )
          )
            .then((res) => {
              setIsSuccess(true);
              if (res.status !== 200) {
                ToastUtils.serverMessage(t(`statusCodes.${res?.code}`));
              } else {
                toast.success(t(`statusCodes.${res?.code}`));
              }
            })
            .catch((e) => {
              if (e.data.code === "REUSED_PASSWORD") {
                ToastUtils.serverError(t(`statusCodes.${e?.data?.code}`));
              } else {
                toast.error(e.data.message);
              }
            });
        }
      } else {
        toast.error(t("errorKeys.passwordNotMatch"));
      }
    } else {
      toast.error(t("errorKeys.logInFail"));
    }
  };

  const handleContinue = () => {
    navigate(getPathPrefix() + "login");
  };

  const isDisable = () => {
    return (
      isEmpty(resetPasswordState.password) ||
      isEmpty(resetPasswordState.confirmPassword)
    );
  };

  return (
    <>
      {isSuccess ? (
        <>
          <div className="pass-check d-flex">
            <i className={icons.solid}></i>
          </div>
          <div className="heading">
            <h4> {t("resetPassword.passwordChange")}</h4>
            <h6> {t("resetPassword.passwordSuccess")}</h6>
          </div>
          <form>
            <FooterButton
              title={t("resetPassword.continue")}
              handleContinue={handleContinue}
            />
          </form>
        </>
      ) : (
        <form className="d-flex flex-column flex-fill justify-content-center">
          <h4
            className="text-primary-app mb-4 text-center"
            style={{ fontWeight: "600" }}
          >
            {t("resetPassword.title")}
          </h4>
          <Input
            icon={
              !showNewPass
                ? "fa-regular fa-eye field-icon"
                : "fa-regular fa-eye-slash field-icon"
            }
            onChange={(e) => handleChange(e, "password")}
            value={resetPasswordState.password}
            placeholder={t("resetPassword.newPasswordPlaceholder")}
            type={showNewPass ? "text" : "password"}
            onClick={() => setShowNewPass((prev) => !prev)}
          />
          <Input
            icon={
              !showConfirmPass
                ? "fa-regular fa-eye field-icon"
                : "fa-regular fa-eye-slash field-icon"
            }
            onChange={(e) => handleChange(e, "confirmPassword")}
            value={resetPasswordState.confirmPassword}
            placeholder={t("resetPassword.confirmPasswordPlaceholder")}
            type={showConfirmPass ? "text" : "password"}
            onClick={() => setShowConfirmPass((prev) => !prev)}
          />
          <FooterButton
            // title={t("language.update_password")}
            title={t("resetPassword.updatePassword")}
            handleContinue={handleSubmit}
            disabled={isDisable()}
            buttonStyle={
              isDisable() ? { opacity: 0.4, cursor: "not-allowed" } : {}
            }
            isLoading={isLoading}
          />
        </form>
      )}
    </>
  );
};

export default ResetPassword;
